import { gql } from '@apollo/client'

export const GET_ADMIN_USERS = gql`
  query GetAdminUsers {
    adminUsers {
      uid email displayName planType maxClients clientCount runsThisMonth disabledAt createdAt
    }
  }
`

export const GET_ADMIN_ACCOUNT = gql`
  query GetAdminAccount($uid: ID!) {
    adminAccount(uid: $uid) {
      uid email displayName planType maxClients clientCount runsThisMonth disabledAt createdAt updatedAt
    }
  }
`

export const GET_WAITLIST = gql`
  query GetWaitlist {
    adminWaitlist {
      id email createdAt approved
    }
  }
`

export const APPROVE_WAITLIST = gql`
  mutation ApproveWaitlist($docId: ID!, $approved: Boolean!) {
    approveWaitlist(docId: $docId, approved: $approved)
  }
`

export const DISABLE_USER = gql`
  mutation DisableUser($uid: ID!, $disabled: Boolean!) {
    disableUser(uid: $uid, disabled: $disabled)
  }
`

export const ADMIN_UPDATE_ACCOUNT = gql`
  mutation AdminUpdateAccount($uid: ID!, $planType: String, $maxClients: Int, $disabledAt: String) {
    adminUpdateAccount(uid: $uid, planType: $planType, maxClients: $maxClients, disabledAt: $disabledAt) {
      uid planType maxClients disabledAt updatedAt
    }
  }
`

export const GET_SYSTEM_PROMPTS = gql`
  query GetSystemPrompts {
    adminSystemPrompts {
      key content
    }
  }
`

export const UPSERT_SYSTEM_PROMPT = gql`
  mutation UpsertSystemPrompt($key: String!, $content: String!) {
    upsertSystemPrompt(key: $key, content: $content) {
      key content
    }
  }
`

export const DELETE_SYSTEM_PROMPT = gql`
  mutation DeleteSystemPrompt($key: String!) {
    deleteSystemPrompt(key: $key)
  }
`
